import { ReactElement, useEffect, useState } from 'react';
import './AILeadershipAssistant.scss';

import { Loading } from 'carbon-components-react';

const AILeadershipAssistant = ({ configuration }: any): ReactElement => {
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    const pageLang = document.documentElement.lang.substring(0, 2) || 'en';

    const getScriptUrl = async () => {
      try {
        const response = await fetch(
          'https://ai-in-action-assistant-backend.1l5zfkwzodcq.us-south.codeengine.appdomain.cloud/static/get-file',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ url: window.location.href, lang: pageLang }),
          },
        );

        if (response.ok) {
          const data = await response.json();
          const scriptUrl = data.url;

          if (scriptUrl) {
            const script = document.createElement('script');
            script.src = scriptUrl;
            script.async = true;
            script.onload = () => {
              console.info('Assistant loaded successfully');
              setLoading(false); // Set loading to false when script loads
            };
            script.onerror = (error) => {
              console.error('Failed to load the Assistant:', error);
              setLoading(false); // Stop loading on error
            };
            document.body.appendChild(script);

            return () => {
              document.body.removeChild(script);
            };
          } else {
            console.error('assistant url is undefined');
            setLoading(false); // Stop loading if url is undefined
          }
        } else {
          console.error('Failed to fetch script URL:', response.status);
          setLoading(false); // Stop loading on API error
        }
      } catch (error) {
        console.error('Error during API request:', error);
        setLoading(false); // Stop loading on API request error
      }
    };

    getScriptUrl();
  }, []);

  return (
    <div className="ai-leadership-assistant widget-styles">
      <div
        id="ai-leadership-assistant-root"
        className={loading ? 'ai-leadership-assistant-hide' : ''}
      ></div>
      <div
        className={
          loading
            ? 'ai-leadership-assistant-loading'
            : 'ai-leadership-assistant-hide'
        }
      >
        <Loading withOverlay={false} />
      </div>
    </div>
  );
};

export default AILeadershipAssistant;
